"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.endorsement = exports.withoutLimits = exports.withoutLimitRange = exports.regular = void 0;
var coverageTypes_1 = require("../constants/coverageTypes");
/**
 * A valid regular coverage instance
 */
exports.regular = {
    id: 0,
    code: '001',
    applyDeductible: false,
    enableUI: true,
    name: 'Daños a la propiedad ajena',
    minCost: 0,
    maxCost: 0,
    limits: [
        { minimun: 0, maximun: 5000, minimum: 0, maximum: 5000 },
        { minimun: 0, maximun: 50000, minimum: 0, maximum: 50000 },
        { minimun: 0, maximun: 100000, minimum: 0, maximum: 100000 },
    ],
    type: { id: 0, code: coverageTypes_1.COVERAGE_TYPE, name: '' },
};
exports.withoutLimitRange = __assign(__assign({}, exports.regular), { limits: [
        { minimum: 100, maximum: 100 },
        { minimum: 200, maximum: 200 },
    ] });
exports.withoutLimits = __assign(__assign({}, exports.regular), { limits: [] });
/**
 * A valid endorsement coverage instance
 */
exports.endorsement = {
    id: 0,
    code: '006',
    applyDeductible: false,
    enableUI: true,
    name: 'Endoso Platinum Plus',
    minCost: 0,
    maxCost: 0,
    limits: [],
    type: { id: 0, code: coverageTypes_1.ENDORSEMENT_TYPE, name: '' },
};
//# sourceMappingURL=mockCoverages.js.map